const { Modal } = wp.components;
const { __ } = wp.i18n;

const PremiumPopup = () => {
  return (
    <Modal title="Pro Feature" onRequestClose={() => {}}>
      <p>
        {__("Unlock HTML5 Video Player Pro Features", "h5vp")} <span className="h5vp_pro_label">{__("Pro", "h5vp")}</span>
      </p>
      <br />
      <a href="https://wpvideoplayer.com" rel="noreferrer" target="_blank" className="button button-primary">
        {__("Learn More", "h5vp")}
      </a>
    </Modal>
  );
};

export default PremiumPopup;
